import { Component, OnInit, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { LoginService } from '../login/login.service';
import { BookingService } from './booking.service'

@Component( {
    selector: 'app-booking',
    templateUrl: './booking.component.html',
    styleUrls: ['./booking.component.css']
} )
export class BookingComponent implements OnInit {

    constructor( private bookingService: BookingService, private loginService: LoginService ) { }

    public errormessage: String;
    public books: Object;
    private clickedBooking: number;
    private popfee:number;
    private validated: boolean;

    ngOnInit() {
        this.bookingService.getBooksFromHotel()
            .subscribe(( data ) => {
                if ( data != null && data.error == null ) {
                    console.log( 'returned bookings json: ' + JSON.stringify( data.books, null, 2 ) );
                    console.dir( 'data.books len: ' + data.books.length);
                    console.dir( 'data.books type: ' + typeof(data.books));
                    if (data.hasOwnProperty('books')) this.books = (data.books as Object);
                } else {  // Book not found, get error message
                    this.errormessage = "Erreur au chargement des données";
                    console.log( 'Erreur au chargement des données' )
                    // this.router.navigate(['/errorpage']);
                }
            } );     
    }
    

    public confirm(imp:any) {
        console.log('Submit called: ' + imp.book + ', validated: ' + imp.validated);
        this.bookingService.updateBooking(imp.book, 'status', '2')
        .subscribe((data) => {
          if (data != null && data.error==null) {
              console.log('Updated booking');
              imp.status=2;
              //location.reload();
          } else {  // Book not found, get error message
            this.errormessage = "Erreur à la mise à jour de la réservation";
            console.log(this.errormessage)
            // this.router.navigate(['/errorpage']);
          }
        });
        // alert('email de confirmation envoyé')
    }
    
    public validate(imp:any) {
        console.log('Validate called: ' + imp.transaction+ ", hotelprice: " + imp.hotelprice);
        this.bookingService.updateTransaction(imp.transaction, imp.hotelprice)
        .subscribe((data) => {
          if (data != null && data.error==null) {
              console.log('Updated transaction');
              imp.validated=true;
          } else {  // Book not found, get error message
            this.errormessage = "Erreur à la mise à jour de la transaction";
            console.log(this.errormessage)
            // this.router.navigate(['/errorpage']);
          }
        });
    }    
    
    public cancel(imp:any) {
        imp.validated=true;
        console.log('imp: ' + imp); 
    }
    
    public getcard(imp:any) {
        this.bookingService.getcard(imp.book, imp.code)
        .subscribe((data) => {
          if (data != null && data.error==null) {
              console.log('Got Card info');
              imp.rawdata=data.rawdata;
          } else {  // Book not found, get error message
            this.errormessage = "Erreur getcard";
            console.log(this.errormessage)
            // this.router.navigate(['/errorpage']);
          }
        }); 
    }    

    private formatoptions(books:any) {  // Unused
        for ( let i in ( books )) {    // Booking loop
            for ( let j in ( books[i].rooms )) {    // Room loop
                console.log( 'Room: '+  JSON.stringify(books[i].rooms[j], null, 2))
                books[i].rooms[j].foptions=''
                for ( let k in ( books[i].rooms[j].options )) {    // Option loop
                    console.log( 'Option: '+  JSON.stringify(books[i].rooms[j].options[k], null, 2))
                    books[i].rooms[j].foptions=books[i].rooms[j].foptions + books[i].rooms[j].options[k] + "\n"
                }
                console.log( 'foptions: '+  JSON.stringify(books[i].rooms[j].foptions, null, 2))
            }
        }
    }
}
